// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// React setup
import React from "react"
import ReactDOM from "react-dom/client"

// Import React components
import CustomFileUpload from "./components/CustomFileUpload"
import Candidates from "./components/Candidates"
import RewardManagement from "./components/RewardManagement"
import DateTime from "./components/DateTime"
import { New as NewWalkIn, IndexWalkIn, EditWalkIn, ShowEntry } from "./components/WalkIn"

// Make components available globally for react_component helper
window.CustomFileUpload = CustomFileUpload
window.Candidates = Candidates
window.RewardManagement = RewardManagement
window.DateTime = DateTime
window.NewWalkIn = NewWalkIn
window.IndexWalkIn = IndexWalkIn
window.EditWalkIn = EditWalkIn
window.ShowEntry = ShowEntry

// React UJS-like mounting for react_component helper
function mountReactComponents() {
  const mountPoints = document.querySelectorAll("[data-react-class]")
  mountPoints.forEach((mountPoint) => {
    // Skip if already mounted
    if (mountPoint.dataset.reactMounted) return

    const className = mountPoint.dataset.reactClass
    const props = JSON.parse(mountPoint.dataset.reactProps || "{}")
    const Component = window[className]
    if (Component) {
      const root = ReactDOM.createRoot(mountPoint)
      root.render(React.createElement(Component, props))
      mountPoint.dataset.reactMounted = "true"
    }
  })
}

document.addEventListener("turbo:load", mountReactComponents)
document.addEventListener("DOMContentLoaded", mountReactComponents)
